// Seed upgrade tiers, mirrored from server CardData.applySeedUpgrades:
//   30 = Refined (MP discount), 60 = Enhanced (+1 die), 100 = Mastered (free-cast chance).
// The old card badge used min(3, floor(level/10)), which saturated at seed 30 — so a
// level-30 and a level-99 seed looked identical. This exposes real progress instead.
export const SEED_TIERS = [
  { at: 30,  name: 'Refined'  },
  { at: 60,  name: 'Enhanced' },
  { at: 100, name: 'Mastered' },
];

// Given a seed level, return the tier reached and the next milestone (null once mastered).
export function seedTierInfo(level) {
  const lvl = level || 0;
  let current = null;
  let next = null;
  for (const t of SEED_TIERS) {
    if (lvl >= t.at) current = t;
    else { next = t; break; }
  }
  return { level: lvl, current, next };
}

// Compact badge text for a card face, e.g. "54→60" (progress) or "★ Mastered".
export function seedBadgeText(level) {
  const { level: lvl, next } = seedTierInfo(level);
  if (!next) return '★ Mastered';
  return `${lvl}→${next.at}`;
}

// Full one-line label, e.g. "Seed 54 — Enhanced at 60" or "Seed 100 — Mastered ★".
export function seedProgressLabel(level) {
  const { level: lvl, current, next } = seedTierInfo(level);
  if (!next) return `Seed ${lvl} — Mastered ★`;
  return `Seed ${lvl} — ${current ? current.name + ', ' : ''}${next.name} at ${next.at}`;
}
